import { render, staticRenderFns } from "./SliderConfig.vue?vue&type=template&id=74dce61a"
import script from "./SliderConfig.vue?vue&type=script&lang=js"
export * from "./SliderConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74dce61a')) {
      api.createRecord('74dce61a', component.options)
    } else {
      api.reload('74dce61a', component.options)
    }
    module.hot.accept("./SliderConfig.vue?vue&type=template&id=74dce61a", function () {
      api.rerender('74dce61a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/Edit/QuestionConfig/SliderConfig.vue"
export default component.exports